import React from "react"
import WhyAia from "../components/whyAia/WhyAia"
import SEO from "../components/seo"
import { getWhyAiaPageJsonLd } from "../utils/jsonld"

const whyaia = () => {
  return (
    <div>
      <SEO jsonLd={getWhyAiaPageJsonLd()} />
      <WhyAia />
    </div>
  )
}

export default whyaia
